module.exports = __webpack_public_path__ + "img/galeria-agua-dulce4.50ed17b0.jpg";